// src/components/admin/SyncFromTemplate.jsx
import { useState } from "react";
import { db, storage } from "../../firebase";
import {
  collection,
  getDocs,
  doc,
  setDoc,
  getDoc,
} from "firebase/firestore";
import {
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
} from "firebase/storage";
import { IS_DEMO } from "../../App";
export default function SyncFromTemplate() {
  const [targetVenue, setTargetVenue] = useState("");
  const [status, setStatus] = useState(null); // { type: "info" | "success" | "error", message: string }
  const [loading, setLoading] = useState(false);

  const templateVenueId = "sala-bankietowa";

  const syncVenue = async () => {
    if (!targetVenue.trim()) {
      setStatus({ type: "error", message: "Podaj nazwę venue (slug)" });
      return;
    }

    const slug = targetVenue.trim().toLowerCase().replace(/\s+/g, "-");

    if (slug === templateVenueId) {
      setStatus({ type: "error", message: "Nie można synchronizować na szablon źródłowy" });
      return;
    }

    setLoading(true);
    setStatus({ type: "info", message: "Sprawdzanie istnienia venue..." });

    try {
      // Sprawdź czy venue już istnieje (czy ma przynajmniej jedną stronę)
      const testRef = doc(db, "venues", slug, "pages", "home");
      const testSnap = await getDoc(testRef);

      if (testSnap.exists()) {
        if (!window.confirm(`Venue "${slug}" już istnieje. Nadpisać wszystkie strony i obrazki?`)) {
          setLoading(false);
          return;
        }
        // Jeśli potwierdzone – kontynuujemy (nadpiszemy wszystko)
      }

      setStatus({ type: "info", message: "Pobieranie stron z szablonu..." });

      // 1. Pobierz wszystkie strony z szablonu
      const templatePagesRef = collection(db, "venues", templateVenueId, "pages");
      const pagesSnap = await getDocs(templatePagesRef);

      const pagesData = [];
      pagesSnap.forEach((d) => {
        pagesData.push({ id: d.id, ...d.data() });
      });

      if (pagesData.length === 0) {
        throw new Error("Szablon nie zawiera żadnych stron");
      }

      // 2. Zapisz wszystkie strony do nowej venue
      setStatus({ type: "info", message: `Kopiowanie ${pagesData.length} stron...` });

      for (const page of pagesData) {
        const newPageRef = doc(db, "venues", slug, "pages", page.id);
        // Usuwamy pola systemowe które nie powinny być kopiowane (np. order jeśli chcesz zachować kolejność szablonu)
        const { order, ...pageDataWithoutOrder } = page;
        await setDoc(newPageRef, pageDataWithoutOrder);
      }

      // 3. Kopiowanie obrazków ze Storage – z pełnym debugowaniem
setStatus({ type: "info", message: "Sprawdzanie i kopiowanie obrazków..." });

let totalCopied = 0;

const copyRecursively = async (sourcePrefixRef) => {
  console.log("Przeszukuję folder:", sourcePrefixRef.fullPath);

  const listResult = await listAll(sourcePrefixRef);

  // Loguj znalezione pliki
  listResult.items.forEach(item => {
    console.log("Znaleziono plik:", item.fullPath);
  });

  // Loguj znalezione podfoldery
  listResult.prefixes.forEach(prefix => {
    console.log("Znaleziono podfolder:", prefix.fullPath);
  });

  // Kopiuj pliki
  await Promise.all(
    listResult.items.map(async (itemRef) => {
      try {
        const url = await getDownloadURL(itemRef);
        const response = await fetch(url);
        if (!response.ok) throw new Error("Bad response");
        const blob = await response.blob();

        // Zamiana nazwy venue w ścieżce
        const pathParts = itemRef.fullPath.split("/");
        pathParts[1] = slug; // venues/[1] = nazwa venue
        const newPath = pathParts.join("/");
        const newFileRef = ref(storage, newPath);

        await uploadBytes(newFileRef, blob);
        totalCopied++;
        console.log("Skopiowano:", itemRef.fullPath, "→", newPath);
      } catch (err) {
        console.error("Błąd kopiowania pliku:", itemRef.fullPath, err);
      }
    })
  );

  // Rekurencja do podfolderów
  for (const prefixRef of listResult.prefixes) {
    await copyRecursively(prefixRef);
  }
};

try {
  const sourceFolderRef = ref(storage, `venues/${templateVenueId}/`);
  await copyRecursively(sourceFolderRef);

  setStatus({
    type: "success",
    message: `Synchronizacja zakończona! Skopiowano ${pagesData.length} stron i ${totalCopied} obrazków.`,
  });
} catch (err) {
  console.error("Błąd podczas kopiowania obrazków:", err);
  setStatus({
    type: "error",
    message: "Błąd kopiowania obrazków: " + err.message,
  });
}
      // Opcjonalnie: wyczyść pole
      setTargetVenue("");
    } catch (err) {
      console.error(err);
      setStatus({ type: "error", message: "Błąd synchronizacji: " + err.message });
    } finally {
      setLoading(false);
      setTimeout(() => setStatus(null), 8000);
    }
  };
  if(!IS_DEMO){return <></>}
  return (
    <div className="mx-6 my-8 bg-white px-8 py-6 shadow rounded-lg">
      <h2 className="text-2xl font-bold mb-6">Synchronizacja z szablonu</h2>
      <p className="text-gray-700 mb-6">
        Skopiuje wszystkie strony i obrazki z venue <strong>sala-bankietowa</strong> do nowej venue.
      </p>

      <div className="max-w-md">
        <label className="block text-sm font-medium mb-2">
          Nazwa nowej venue (slug, np. moja-restauracja)
        </label>
        <input
          type="text"
          value={targetVenue}
          onChange={(e) => setTargetVenue(e.target.value)}
          placeholder="np. palac-wilanow"
          className="w-full border rounded px-5 py-3 mb-4"
          disabled={loading}
        />

        <button
          onClick={syncVenue}
          disabled={loading || !targetVenue.trim()}
          className="w-full bg-emerald-600 text-white py-4 rounded font-bold hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Synchronizowanie..." : "Rozpocznij synchronizację"}
        </button>
      </div>

      {status && (
        <div
          className={`mt-6 px-6 py-4 rounded-lg font-medium ${
            status.type === "success"
              ? "bg-emerald-100 text-emerald-800"
              : status.type === "error"
              ? "bg-red-100 text-red-800"
              : "bg-blue-100 text-blue-800"
          }`}
        >
          {status.message}
        </div>
      )}
    </div>
  );
}